import { Button } from 'react-bootstrap'
import pathUtil from '@leverege/path'
import classnames from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'
import Editor from '@monaco-editor/react'

import { Flex } from '~/views'

import style from './style.css'

import S from './ScriptCodeEditor.css'

export default class ScriptCodeEditor extends React.Component {

  static propTypes = {
    script : PropTypes.object.isRequired,
    user : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    onChangeUser : PropTypes.func.isRequired,
    scriptPath : PropTypes.string.isRequired,
    editedCode : PropTypes.string.isRequired
  }

  changePath = ( path, value, err ) => {
    const { onChange, script } = this.props
    if ( err ) {
      console.log( `error setting ${path} to ${value}` )
      return
    }
    onChange( { target : script, path, value } )
  }

  changeCode = ( text ) => {
    this.changePath( 'code', text, false )
  }

  changeUser = ( path, value, err ) => {
    const { onChangeUser, user } = this.props
    if ( err ) {
      console.log( `error setting user ${path} to ${value}` )
      return
    }
    onChangeUser( { target : user, path, value } )
  }

  render() {
    const { script, scriptPath, disabled, actionText, headerText, editedCode, enableSave } = this.props

    const operationInProgress = script.status !== 'active' &&
      script.status !== 'not_deployed' &&
      script.status !== 'offline'
    const codeInputDisabled = disabled || operationInProgress
    const value = pathUtil( scriptPath ).get( script, '' )

    const saveDisabled = value === editedCode
    const buttonDisabled = operationInProgress || !saveDisabled

    if ( script == null ) {
      return <div />
    }

    return (
      <Flex className={style.editorFlex} variant="vSpace" direction="column" align="center" justify="flex-start">
        <Flex className={classnames( style.headerRow )} variant="vSpace" direction="row" align="center">
          <span className={style.header}>
            { headerText || 'Input your Javascript code below.' }
          </span>
          <div className={style.deployCodeWrapper}>
            {
              enableSave ?
                (
                  <Button 
                    className={style.deployCode} 
                    onClick={saveDisabled ? null : () => { this.changePath( 'save' ) }}
                    disabled={saveDisabled}> 
                    <span className={style.text}>
                      Save Script
                    </span>
                    <i className="fa fa-save" />
                  </Button>
                ) :
                null
            }
            <Button 
              className={style.deployCode} 
              onClick={buttonDisabled ? null : () => { this.changePath( 'deployedCode' ) }}
              disabled={buttonDisabled}> 
              <span className={style.text}>
                { actionText || 'Deploy' }
              </span>
              <i className="fa fa-ship" />
            </Button>
          </div>
        </Flex>
        <Editor
          className={S.editor}
          options={{ readOnly : codeInputDisabled }}
          height="80%"
          defaultLanguage="javascript"
          value={editedCode}
          onChange={this.changeCode}
          theme="vs-dark" />
      </Flex>
    ) 
  }
}
